/**
 * Boundary validation for API responses.
 *
 * A 200 with the wrong body shape is a FAILURE, not data. Without this, a
 * `{"data":{}}` where a list was expected flows into state and detonates at
 * the first `.map` / `.filter` / `.some`:
 *
 *   EP-067  "integrations.map is not a function" rendered as row copy
 *   EP-088  "shares.filter is not a function" threw during render and took
 *           the whole Settings view down with it
 *   ExportModal.tsx  `schema.fields.some(...)` on a non-schema 200 crashed
 *           the entire sidebar (latent, found by the same sweep)
 *
 * Validating at the boundary turns all three into an ordinary handled error
 * with copy the user can act on.
 */
/** Thrown when a response parsed fine but is not the shape we require. */
export class MalformedResponseError extends Error {
    what;
    constructor(what) {
        super(`The server sent an unexpected response for ${what}. Try again in a moment.`);
        this.what = what;
        this.name = 'MalformedResponseError';
    }
}
/**
 * Assert a value is an array before it becomes state.
 *
 * `what` names the data for the user, so keep it a plain noun phrase
 * ("integrations", "shared links"): it appears in the surfaced copy.
 */
export function expectArray(value, what) {
    if (!Array.isArray(value))
        throw new MalformedResponseError(what);
    return value;
}
//# sourceMappingURL=apiShape.js.map